export default "__VITE_ASSET__0bda5969__"